<template>
  <div class="component" ref="component">
    <div class="display">
      <div v-if="value" v-on:click="toggleDatepicker">
        {{ getDate() }} <i class="material-icons">edit</i>
      </div>
      <div v-else>
        <button class="btn" v-on:click="toggleDatepicker">{{ $t('datepicker.selectDate') }}</button>
      </div>
    </div>
    <div class="picker" :class="{ 'is-visible': pickerVisible }" >
      <transition name="overlay">
        <div class="picker__overlay" v-if="pickerVisible" v-on:click="toggleDatepicker"></div>
      </transition>
      <transition name="containter">
        <div class="picker__containter" v-if="pickerVisible">
          <div class="header">
            <div class="title">{{ title }}</div>
            <div class="caption">{{ caption }}</div>
            <button class="toggle" v-on:click="prevMonth" v-if="dayView"><i class="material-icons">chevron_left</i></button>
            <button class="toggle" v-on:click="nextMonth" v-if="dayView"><i class="material-icons">chevron_right</i></button>
          </div>
          <div class="year-view" v-if="yearView" ref="yearView">
            <div class="year-list">
              <button
                class="year-item"
                :class="{ 'is-selected': year === selected.year }"
                v-for="year in yearList"
                v-on:click="setTempYear(year)"
                v-bind:key="year"
              >
                {{ year }}
              </button>
            </div>
          </div>
          <div class="month-view" v-if="monthView">
            <div class="month-list">
              <button
                class="month-item"
                v-for="month in 12"
                v-on:click="setTempMonth(month - 1)"
                v-bind:key="month"
              >
                {{ monthNames()[month - 1] }}
              </button>
            </div>
          </div>
          <div class="day-view" v-if="dayView">
            <div class="weekday-list">
              <button
                class="weekday-item"
                v-for="weekday in 7"
                v-bind:key="weekday"
              >
                {{ weekdayNames()[weekday - 1] }}
              </button>
            </div>
            <div
              class="day-list"
              :class="firstDayOffset()">
              <button
                class="day-item"
                :class="{ 'is-selected': day.string === selected.string }"
                v-for="day in dayList"
                v-on:click="setValue(day.date)"
                v-bind:key="temp.year + temp.month + day.number"
              >
                {{ day.number }}
              </button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Datepicker',
  props: {
    locale: {
      type: String,
      default: 'zh-Hant',
    },
    mode: {
      type: String,
      required: false,
      default: 'future',
    },
    value: {
      default: null,
    },
    yearFirst: {
      type: Boolean,
      required: false,
      default: false,
    },
    yearLength: {
      type: Number,
      required: false,
      default: 10,
    },
    yearOffset: {
      type: Number,
      required: false,
      default: 0,
    },
    displayFormat: {
      type: String,
      required: false,
      default: 'l',
    },
  },
  data() {
    return {
      pickerVisible: false,
      yearView: true,
      monthView: false,
      dayView: false,
      currentYear: (new Date()).getFullYear(),


      manual: false,

      temp: {
        year: null,
        month: null,
        day: null,
      },
    };
  },
  computed: {
    selected() {
      if (this.value) {
        return {
          year: parseInt(this.$moment(this.value).format('YYYY'), 10),
          date: this.$moment(this.value).toDate(),
          string: this.$moment(this.value).toString(),
        };
      }
      return {
        year: null,
        date: null,
        string: null,
      };
    },
    title() {
      if (this.monthView) {
        return this.$moment([this.temp.year]).format('YYYY');
      } else if (this.dayView) {
        return this.$moment([this.temp.year, this.temp.month]).format('YYYY/M');
      }

      return null;
    },
    caption() {
      if (this.yearView) {
        return this.$i18n.t('datepicker.selectYear');
      } else if (this.monthView) {
        return this.$i18n.t('datepicker.selectMonth');
      }
      return this.$i18n.t('datepicker.selectDate');
    },
    yearList() {
      return Array.from(
        new Array(this.yearLength),
        (val, index) => index + this.currentYear + this.yearOffset,
      );
    },
    dayList() {
      const daysInMonth = this.$moment([this.temp.year, this.temp.month]).daysInMonth();
      return Array.from(new Array(daysInMonth), (val, index) => ({
        number: index + 1,
        date: this.$moment([this.temp.year, this.temp.month, index + 1]).toDate(),
        string: this.$moment([this.temp.year, this.temp.month, index + 1]).toString(),
      }));
    },
  },
  watch: {
    // pickerVisible(value) {
    //   if (value) {
    //     this.$nextTick()
    //       .then(() => {
    //         this.$refs.yearView.getElementsByClassName('is-selected')[0].scrollIntoView({});
    //       });
    //   }
    // },
  },
  methods: {
    updateLocale() {
      this.$moment.locale(this.$i18n.locale);
    },
    getDate() {
      this.updateLocale();
      return this.$moment(this.value).format('l');
    },
    monthNames() {
      this.updateLocale();
      return this.$moment.monthsShort();
    },
    weekdayNames() {
      this.updateLocale();
      return this.$moment.weekdaysMin();
    },
    toggleDatepicker() {
      this.pickerVisible = !this.pickerVisible;
      if (this.yearFirst) {
        this.dayView = false;
        this.monthView = false;
        this.yearView = true;
      }
    },
    setTempYear(value) {
      this.temp.year = value;
      this.yearView = false;
      this.monthView = true;
    },
    setTempMonth(value) {
      this.temp.month = value;
      this.monthView = false;
      this.dayView = true;
    },
    setValue(date) {
      this.$emit('update:date', date);
      this.toggleDatepicker();
    },
    firstDayOffset() {
      return `offset-${this.$moment([this.temp.year, this.temp.month]).format('d')}`;
    },
    prevMonth() {
      if (this.temp.month >= 1) {
        this.temp.month -= 1;
      } else {
        this.temp.year -= 1;
        this.temp.month = 11;
      }
    },
    nextMonth() {
      if (this.temp.month < 11) {
        this.temp.month += 1;
      } else {
        this.temp.year += 1;
        this.temp.month = 0;
      }
    },
    toggleManual() {
      this.manual = !this.manual;
    },
  },
};
</script>

<style lang="sass" scoped>
@import '../../../assets/sass/compoments/o-form.sass'
.o-form__input
  margin-bottom: .5em

.display
  cursor: pointer

  font-size: 1.5rem

  .material-icons
    opacity: .5

    transform: translateY(2px)

.btn
  border-radius: 99px

  background-color: #eee

  font-weight: bold

  appearance: none

  &:active
    outline: none

  &:not(:last-child)
    margin-right: .5em

.picker
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  display: flex
  align-items: center
  z-index: -1

  &.is-visible
    z-index: 1040

.picker__overlay
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1040
  opacity: .7

  background-image: linear-gradient(0deg, rgba(44,43,43,0.95) 0%, rgba(33,32,32,0.95) 100%)

.picker__containter
  position: relative
  width: 100vw
  max-height: 75vh
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, .5)
  overflow: hidden
  z-index: 1050
  margin: 0 auto

  border-radius: 10px

  background-color: white

  @media only screen and (min-width : 768px)
    max-width: 375px

.header
  position: relative
  padding: 10px

  background-color: #ffea00
  text-align: center

.caption
  font-size: 0.75rem
  font-weight: bold
  color: rgba(0, 0, 0, .25)

.toggle
  position: absolute
  top: 0
  right: auto
  bottom: 0
  left: 0

  border: none

  background: none

  -webkit-appearance: none
  cursor: pointer

  &:last-child
    top: 0
    right: 0
    bottom: 0
    left: auto

  &:active,
  &:focus
    opacity: .9

    outline: none

  .material-icons
    padding: 6px

.year-view
  max-height: 20em
  overflow: auto
  -webkit-overflow-scrolling: touch

.year-item
  width: 100%
  padding: .5em .2em
  display: block
  opacity: .75
  background-color: white

  border: none

  text-align: center

  cursor: pointer
  appearance: none

  &:active
    opacity: 1

    background-color: #ffea00

    font-weight: bold

    outline: none

  &.is-selected
    background-color: #eee

    font-weight: bold

.month-list
  display: flex
  flex-wrap: wrap

.month-item
  width: 33.3333%
  padding: 1em .5em
  opacity: .75
  background-color: white

  border: none

  text-align: center

  cursor: pointer
  appearance: none

  &:active
    opacity: 1

    font-weight: bold

    outline: none

.weekday-list
  margin: 1em .25em
  display: flex
  flex-wrap: wrap

.weekday-item
  width: 14.2847%
  opacity: .25
  background-color: white

  border: none

  text-align: center
  font-size: 0.75rem
  font-weight: bold

  appearance: none

.day-list
  margin: 1em .25em
  display: flex
  flex-wrap: wrap

  min-height: 12em

  &.offset-1
    .day-item:first-child
      margin-left: calc(14.2847% * 1)

  &.offset-2
    .day-item:first-child
      margin-left: calc(14.2847% * 2)

  &.offset-3
    .day-item:first-child
      margin-left: calc(14.2847% * 3)

  &.offset-4
    .day-item:first-child
      margin-left: calc(14.2847% * 4)

  &.offset-5
    .day-item:first-child
      margin-left: calc(14.2847% * 5)

  &.offset-6
    .day-item:first-child
      margin-left: calc(14.2847% * 6)

.day-item
  width: 14.2847%
  padding: .5em .25em
  opacity: .75
  display: flex
  flex-direction: column
  align-items: center
  background-color: white

  border-radius: 99px
  border: none

  text-align: center
  font-size: 1em

  appearance: none
  cursor: pointer

  &:active
    opacity: 1

    background-color: #ffea00

    font-weight: bold

    outline: 0

  &.is-selected
    opacity: 1

    background-color: #eee

    font-weight: bold

.overlay-enter-active,
.overlay-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1)

.overlay-enter,
.overlay-leave-to
  opacity: 0

.containter-enter-active,
.containter-leave-active
  transition: opacity .25s cubic-bezier(0, 0, .2, 1), transform .15s cubic-bezier(0, 0, .2, 1)

.containter-enter,
.containter-leave-to
  opacity: 0
  transform: translateY(150px) scale(.8)
</style>
